var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon fill-current",attrs:{"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"20","height":"2"}}),_c('rect',{attrs:{"y":"6","width":"20","height":"2"}}),_c('rect',{attrs:{"y":"12","width":"20","height":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }